<template>
  <div class="modal-overlay">
    <div class="modal">
      <h3 class="modal-title">修改设备项目</h3>

      <div
        v-for="(project, index) in localProjects"
        :key="index"
        class="project-row"
      >
        <select v-model="localProjects[index]" class="project-select">
          <option
            v-for="item in allProjects"
            :key="item"
            :value="item"
          >
            {{ item }}
          </option>
        </select>
        <button @click="removeProject(index)" class="remove-btn">❌</button>
      </div>

      <button @click="addProject" class="add-btn">➕ 添加项目</button>

      <div class="modal-buttons">
        <button class="save-btn" @click="saveProjects">保存</button>
        <button class="cancel-btn" @click="$emit('close')">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditDeviceProjectModal",
  props: {
    deviceId: String,
    projects: Array,
    allProjects: Array,
  },
  data() {
    return {
      localProjects: Array.isArray(this.projects) ? [...this.projects] : [],
    };
  },
  watch: {
    projects: {
      immediate: true,
      handler(newVal) {
        this.localProjects = Array.isArray(newVal) ? [...newVal] : [];
      },
    },
  },
  methods: {
    addProject() {
      this.localProjects.push("");
    },
    removeProject(index) {
      this.localProjects.splice(index, 1);
    },
    saveProjects() {
      // 过滤空值并发送给父组件
      this.$emit('save', {
      device_id: this.deviceId,
      projects: this.localProjects.filter(p => p !== "")
    });
  }
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 半透明背景 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #fff;
  padding: 30px 40px;
  border-radius: 10px;
  width: 500px;
  max-width: 90%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.modal-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.project-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.project-select {
  flex: 1;
  padding: 8px 10px;
  font-size: 18px;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-right: 10px;
}

.remove-btn {
  background-color: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #e74c3c;
}

.add-btn {
  margin-top: 10px;
  background-color: #3498db;
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}

.add-btn:hover {
  background-color: #2980b9;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
}

.save-btn {
  background-color: #2ecc71;
  color: #fff;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
}

.save-btn:hover {
  background-color: #27ae60;
}

.cancel-btn {
  background-color: #ccc;
  color: #333;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
}

.cancel-btn:hover {
  background-color: #b3b3b3;
}
</style>
